import { ConnectionIndicator } from '@/components/ui';
import { useOverview } from '@/hooks/useOverview';
import { StatsRow } from '@/components/overview/StatsRow';
import { InboxSummaryPanel } from '@/components/overview/InboxSummaryPanel';
import { RecentActivitiesPanel } from '@/components/overview/RecentActivitiesPanel';
import { TaskSummaryPanel } from '@/components/overview/TaskSummaryPanel';
import { ActiveUsersPanel } from '@/components/overview/ActiveUsersPanel';
import { RunningAgentsPanel } from '@/components/overview/RunningAgentsPanel';
import { UpcomingSchedulesPanel } from '@/components/overview/UpcomingSchedulesPanel';

export default function OperatorOverview() {
  const { overview, isLoading, isError, isConnected, diagnostics } = useOverview();

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between gap-4">
        <h1 className="text-2xl font-bold text-foreground">Overview</h1>
        <ConnectionIndicator
          isConnected={isConnected}
          diagnostics={diagnostics}
          className="mr-3"
        />
      </div>

      {isError && !overview && (
        <div className="rounded-lg border border-destructive/40 bg-destructive/10 px-4 py-3 text-sm text-destructive">
          Couldn't load overview. The page will retry automatically.
        </div>
      )}

      <StatsRow
        stats={overview?.stats}
        activeRunsCount={overview?.lists.runningAgents?.length}
        isLoading={isLoading}
      />

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
        <div className="space-y-6 lg:col-span-2">
          <InboxSummaryPanel
            unreadCount={overview?.stats.inboxUnread}
            isLoading={isLoading}
          />
          <RecentActivitiesPanel
            items={overview?.lists.recentActivities}
            isLoading={isLoading}
          />
          <TaskSummaryPanel
            tasks={overview?.lists.delegatedTasks}
            isLoading={isLoading}
          />
        </div>
        <div className="space-y-6">
          <ActiveUsersPanel data={overview?.lists.activeUsers} isLoading={isLoading} />
          <RunningAgentsPanel
            runs={overview?.lists.runningAgents}
            isLoading={isLoading}
          />
          <UpcomingSchedulesPanel
            items={overview?.lists.upcomingSchedules}
            isLoading={isLoading}
          />
        </div>
      </div>
    </div>
  );
}
